import liverpool2 from "../../../images/liverpool2.jpg"
import liverpool from "../../../images/liverpool.jpg"
import city2 from "../../../images/city2.jpg"
import city from "../../../images/city.jpg"
import fcb from "../../../images/fcb.jpg"
import manutd from "../../../images/Manutd.png"
import manutd2 from "../../../images/manutd2.jpg"
import real from "../../../images/real.jpg"
import atletico from "../../../images/atletico.jpg"
import atletico2 from "../../../images/atletico2.jpg"
import psg from "../../../images/psg.jpg"
import psg2 from "../../../images/psg2.jpg"
import chelsea3 from "../../../images/chelsea3.jpg"
import chelsea2 from "../../../images/Chelsea2.jpg"
import ajax2 from "../../../images/ajax2.png"
import arsenal from "../../../images/arsenal.png"
import tottenham from "../../../images/tottenham.jpg"
import tottenham2 from "../../../images/tottenham2.jpg"



const data = {
    productItems: [
        {
            id: "1",
            name: "Liverpool FC - Home",
            price: 4999,
            image: liverpool2
        },

        {
            id: "2",
            name: "Liverpool FC - Away",
            price: 4999,
            image: liverpool
        },
        {
            id: "3",
            name: "Manchester City FC - Home",
            price: 4999,
            image: city2
        },
        {
            id: "4",
            name: "Manchester City FC - Away",
            price: 4999,
            image: city
        },
        {
            id: "5",
            name: "FC Barcelona - Home",
            price: 4999,
            image: fcb
        },
        {
            id: "6",
            name: "Manchester United FC - Home",
            price: 4999,
            image: manutd
        },
        {
            id: "7",
            name: "Manchester United FC - Away",
            price: 4999,
            image: manutd2
        },
        {
            id: "8",
            name: "Real Madrid - Home",
            price: 4999,
            image: real
        },
        {
            id: "9",
            name: "Atletico Madrid FC - Home",
            price: 4999,
            image: atletico
        },
        {
            id: "10",
            name: "Atletico Madrid FC - Away",
            price: 4999,
            image: atletico2
        },

        {
            id: "11",
            name: "PSG - Home",
            price: 4999,
            image: psg
        },
        {
            id: "12",
            name: "PSG - Away",
            price: 4999,
            image: psg2
        },
        {
            id: "13",
            name: "Chelesa FC - Home",
            price: 4999,
            image: chelsea3
        },
        {
            id: "14",
            name: "Chelsea FC - Away",
            price: 4999,
            image: chelsea2
        },
        {
            id: "15",
            name: "Ajax FC - Away",
            price: 4999,
            image: ajax2
        },
        {
            id: "16",
            name: "Arsenal FC - Home",
            price: 4999,
            image: arsenal
        },
        {
            id: "17",
            name: "Tottenham Hotspur FC - Home",
            price: 4999,
            image: tottenham
        },
        {
            id: "18",
            name: "Tottenham Hotspur FC - Away",
            price: 4999,
            image: tottenham2
        }
    ]
}

export default data 